import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import { cn } from '@ui/lib/utils.js';

export const pFieldCvaConfig = {
    variants: {
        orientation: {
            vertical: ['flex-col', '[&>*]:w-full', '[&>.sr-only]:w-auto'],
            horizontal: [
                'flex-row',
                'items-center',
                '[&>[data-slot=field-label]]:flex-auto',
                'has-[>[data-slot=field-content]]:items-start',
                'has-[>[data-slot=field-content]]:[&>[role=checkbox],[role=radio]]:mt-px',
            ],
            responsive: [
                'flex-col',
                '[&>*]:w-full',
                '[&>.sr-only]:w-auto',
                '@md/field-group:flex-row',
                '@md/field-group:items-center',
                '@md/field-group:[&>*]:w-auto',
                '@md/field-group:[&>[data-slot=field-label]]:flex-auto',
                '@md/field-group:has-[>[data-slot=field-content]]:items-start',
                '@md/field-group:has-[>[data-slot=field-content]]:[&>[role=checkbox],[role=radio]]:mt-px',
            ],
        },
    },
    defaultVariants: {
        orientation: 'vertical',
    },
} as const;

export const pFieldVariants = cva(
    cn('group/field', 'flex', 'w-full', 'gap-1 data-[invalid=true]:text-foreground-destructive'),
    pFieldCvaConfig,
);

export type PFieldVariants = VariantProps<typeof pFieldVariants>;
export const P_FIELD_ORIENTATION_VARIANTS = Object.keys(pFieldCvaConfig.variants.orientation);
export type PFieldOrientationVariant = keyof typeof pFieldCvaConfig.variants.orientation;

export { default as PField } from './PField.vue';
export { default as PFieldContent } from './PFieldContent.vue';
export { default as PFieldDescription } from './PFieldDescription.vue';
export { default as PFieldError } from './PFieldError.vue';
export { default as PFieldGroup } from './PFieldGroup.vue';
export { default as PFieldLabel } from './PFieldLabel.vue';
export { default as PFieldLegend } from './PFieldLegend.vue';
export { default as PFieldSeparator } from './PFieldSeparator.vue';
export { default as PFieldSet } from './PFieldSet.vue';
export { default as PFieldTitle } from './PFieldTitle.vue';
